// src/oura/lib/detectReason.ts
//
// When New Scan's prefill was refused because the domain is not showing the
// business's own site (ourteam-backend#5906, #4241).
//
// The backend answers 200 with every field empty, `confidence: "low"`,
// `reason_code: "NOT_THE_BUSINESS_SITE"` and a plain `reason`. Without this the
// operator would see a blank form and no explanation, and might take the empty
// fields for "the site has nothing on it".

import type { AeoDetectedBusiness } from "@service/aeo";

export const NOT_THE_BUSINESS_SITE = "NOT_THE_BUSINESS_SITE";

/**
 * The backend's sentence to show above the form, or null.
 *
 * Only for that one code, and only with a sentence to show: any other reason
 * code, a missing `reason`, or a blank one is the modal's existing behaviour.
 * The sentence is shown as the backend wrote it.
 */
export function notBusinessSiteReason(d: Pick<AeoDetectedBusiness, "reason_code" | "reason">): string | null {
    if (d.reason_code !== NOT_THE_BUSINESS_SITE) return null;
    const text = typeof d.reason === "string" ? d.reason.trim() : "";
    return text === "" ? null : text;
}
